/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'

import { red500 } from 'material-ui/styles/colors'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

const messages = defineMessages({
  CANCEL: {
    id: 'alertModal.CANCEL',
    defaultMessage: 'CANCEL'
  },
  CLOSE: {
    id: 'alertModal.CLOSE',
    defaultMessage: 'CLOSE'
  },
  CONFIRM: {
    id: 'alertModal.CONFIRM',
    defaultMessage: 'CONFIRM'
  },
  DELETE: {
    id: 'alertModal.DELETE',
    defaultMessage: 'DELETE'
  },
  MESSAGE: {
    id: 'alertModal.MESSAGE',
    defaultMessage: 'MESSAGE'
  }
})

class AlertModal extends React.Component {
  render () {
    return (
      <Dialog
        autoScrollBodyContent={this.props.autoScrollBodyContent || false}
        autoDetectWindowHeight={this.props.autoDetectWindowHeight || false}
        actions={[
          this.props.handleCancel
            ? <FlatButton
              label={this.props.cancellationLabel ? this.props.cancellationLabel : this.props.intl.formatMessage(messages.CANCEL)}
              onClick={this.props.handleCancel}
              secondary={true}
              disabled={this.props.cancelDisabled}
            />
            : undefined,
          <FlatButton
            label={this.props.confirmationLabel ? this.props.confirmationLabel : this.props.intl.formatMessage(messages[this.props.type])}
            backgroundColor={this.props.type === AlertModalWithTrans.DELETE ? red500 : null}
            style={{marginLeft: 10}}
            disabled={this.props.confirmDisabled}
            primary
            onClick={this.props.handleConfirm}
          />
        ]}
        modal={this.props.modal !== true ? false : true}
        open={this.props.open}
        title={this.props.title}
        contentStyle={this.props.contentStyle || undefined}
        bodyStyle={this.props.bodyStyle || undefined}
        style={this.props.style || undefined}
        repositionOnUpdate={false}
        onRequestClose={this.props.modal !== true ? this.props.handleCancel : undefined}
      >
        {
          this.props.children
        }
      </Dialog>
    )
  }
}

const AlertModalWithTrans = injectIntl(AlertModal)

AlertModalWithTrans.DELETE = 'DELETE'
AlertModalWithTrans.MESSAGE = 'MESSAGE'
AlertModalWithTrans.CONFIRM = 'CONFIRM'
AlertModalWithTrans.CLOSE = 'CLOSE'

export default AlertModalWithTrans



// WEBPACK FOOTER //
// ./src/generic/dialog/AlertModal.js